import React from 'react';
import { motion } from 'framer-motion';

interface GoldenRopeProps {
  isDropped: boolean;
}

const GoldenRope: React.FC<GoldenRopeProps> = ({ isDropped }) => {
  return (
    <div className="relative w-full h-12 flex items-center justify-center overflow-visible pointer-events-none">
      {/* Golden Hook Left */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full border-4 border-[#d4af37] bg-[#8B6508] shadow-[0_0_15px_rgba(212,175,55,0.5)] z-20"></div>
      
      {/* The Rope */}
      <motion.svg
        width="100%"
        height="120"
        viewBox="0 0 800 120"
        preserveAspectRatio="none"
        className="absolute top-0 z-10"
        initial={false}
        animate={isDropped ? { y: 200, opacity: 0, rotate: 5 } : { y: 0, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeIn" }}
      >
        <path
          d="M 32 40 Q 400 120 768 40"
          fill="transparent"
          stroke="#d4af37"
          strokeWidth="12"
          strokeLinecap="round"
          className="drop-shadow-[0_4px_10px_rgba(0,0,0,0.5)]"
        />
        {/* Rope Texture effect */}
        <path
          d="M 32 40 Q 400 120 768 40"
          fill="transparent"
          stroke="#8B6508"
          strokeWidth="4"
          strokeDasharray="10 10"
          strokeLinecap="round"
        />
      </motion.svg>

      {/* Golden Hook Right */}
      <div className="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full border-4 border-[#d4af37] bg-[#8B6508] shadow-[0_0_15px_rgba(212,175,55,0.5)] z-20"></div>
    </div>
  );
};

export default GoldenRope;
